import { MediaPlayerParams } from '../learniz/interactivities';
import { ProductEdited, ProductType } from './product';
import { ToolsDocument } from './tools-document';

export class AttachmentEdited implements ProductEdited<AttachmentModel> {
  active?: boolean;
  data: AttachmentModel;
  name: string;
  productPerimeterSlug?: string;
  productType?: ProductType;
  publishedAt?: Date;
  slug: string;
  subType?: string | AttachmentType;
  updatedAt?: Date;
  visible?: boolean;
}

export class AttachmentModel {
  subType: AttachmentType;
  link?: string;
  doc?: ToolsDocument;
  mediaParams?: MediaPlayerParams;
  duration?: string;

  constructor(attachment: AttachmentModel) {
    this.subType = attachment?.subType ?? AttachmentType.LINK;
    this.link = attachment?.link ?? '';
    this.doc = new ToolsDocument(attachment?.doc) ?? new ToolsDocument();
    this.mediaParams = new MediaPlayerParams(attachment?.mediaParams) ?? new MediaPlayerParams();
    this.duration = attachment?.duration;
  }
}

export enum AttachmentType {
  FILE = 'file',
  LINK = 'link',
  VIDEO = 'video',
  AUDIO = 'audio',
}
